import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './BlurCard.css';
import React, { useEffect, useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import bluePlusImg from '../../../resources/icons/blue-plus.svg';
import { ReactComponent as Padlock } from '../../../resources/icons/padlock-v2.svg';
import { isNil, isNotNil } from '../../../utils/IsNil';
import { canUseDOM, getGlobalDictionaryTerm, getMediaHost, injectImageResolution, pathJoin } from '../../../utils';
import { useSitecoreContext } from '../../../utils/hooks/UseSitecoreContext';
import { styled } from 'linaria/lib/react';
import { qsToObject } from '../../../utils/querystring';
import Reminder from '../../atoms/Reminder/Reminder';
var EBlurCardImageTypes = /*#__PURE__*/function (EBlurCardImageTypes) {
  EBlurCardImageTypes["event"] = "event";
  EBlurCardImageTypes["deals"] = "deals";
  return EBlurCardImageTypes;
}(EBlurCardImageTypes || {});
var isShowRuleIsHide = function isShowRuleIsHide(hint) {
  return (new Date(hint.showRuleShowStartDate).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0) || isNil(hint.showRuleShowStartDate) && hint.showRuleIsHide) && hint.showRuleIsHide;
};
var BlurCard = function BlurCard(_ref) {
  var hint = _ref.hint,
    lang = _ref.lang,
    cardType = _ref.cardType,
    hitAnalytics = _ref.hitAnalytics,
    hitParams = _ref.hitParams,
    reminderTheme = _ref.reminderTheme,
    countryItems = _ref.countryItems,
    hitInSlider = _ref.hitInSlider,
    showWithAnimation = _ref.showWithAnimation,
    isEventBlur = _ref.isEventBlur;
  var sitecoreContext = useSitecoreContext();
  var _useState = useState(function () {
      return canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  var ThisWillBeRevealedOn = getGlobalDictionaryTerm(sitecoreContext, 'ThisWillBeRevealedOn') || 'This will be revealed on';
  var injectImageWidthAndHeight = function injectImageWidthAndHeight(width, height) {
    return injectImageResolution(pathJoin([getMediaHost(), '']), width, height);
  };

  /*   const reminderTheme: Array<String> = useMemo(() => {
  
      return [colorSettings['--component-background-color'], colorSettings['--component-color']];
  
    }, [colorSettings]) */

  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener("resize", function () {
        setIsMobile(window.matchMedia("(max-width: 992)").matches);
      });
    }
    return function () {
      if (canUseDOM) {
        window.addEventListener("resize", function () {
          setIsMobile(window.matchMedia("(max-width: 992)").matches);
        });
      }
    };
  }, []);
  var eventImage = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: injectImageWidthAndHeight(340, 243)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageWidthAndHeight(340, 243)
  }));
  var dealsImage = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: injectImageWidthAndHeight(580, 420)
  }), /*#__PURE__*/React.createElement("img", {
    src: injectImageWidthAndHeight(325, 135)
  }));
  var mediaMap = {
    "event": eventImage,
    "deals": dealsImage
  };
  var defaultReturnValue = {
    padding: 0,
    cw: '',
    ch: '',
    isVerticalImage: false
  };
  var getImageSizes = function getImageSizes(children) {
    if (typeof window === 'undefined') return defaultReturnValue;
    return children.reduceRight(function (acc, child) {
      var _child$props = child.props,
        src = _child$props.src,
        srcSet = _child$props.srcSet,
        media = _child$props.media;
      var _ref2 = media ? qsToObject(srcSet) : qsToObject(src),
        cw = _ref2.cw,
        ch = _ref2.ch;
      if (!cw || !ch) return acc;
      var mq = media && window.matchMedia(media);
      if (media && (!mq || !mq.matches)) return acc;
      var padding = parseInt(ch) * 100 / parseInt(cw);
      var isVerticalImage = padding > 100;
      return {
        padding: padding,
        cw: cw,
        ch: ch,
        isVerticalImage: isVerticalImage
      };
    }, defaultReturnValue);
  };
  var _getImageSizes = getImageSizes(mediaMap[cardType].props.children),
    padding = _getImageSizes.padding,
    cw = _getImageSizes.cw,
    ch = _getImageSizes.ch,
    isVerticalImage = _getImageSizes.isVerticalImage;
  return /*#__PURE__*/React.createElement(CardStyledWrapper, {
    className: "".concat(commonStyles),
    cardType: cardType
  }, /*#__PURE__*/React.createElement(ImageStyledWrapper, {
    className: "empty-placeholder blur-empty-placeholder",
    padding: padding,
    cw: cw,
    ch: ch,
    isVerticalImage: isVerticalImage,
    cardType: cardType
  }, /*#__PURE__*/React.createElement("div", {
    className: "hiddenImageContainer"
  }, /*#__PURE__*/React.createElement(Padlock, {
    className: "padlockIcon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "comingSoonText"
  }, ThisWillBeRevealedOn), isNotNil(hint.showRuleShowStartDate) ? /*#__PURE__*/React.createElement("span", {
    className: "comingSoonDate"
  }, new Intl.DateTimeFormat(lang, {
    month: 'long'
  }).format(new Date(hint.showRuleShowStartDate)), ' ', new Date(hint.showRuleShowStartDate).getDate()) : null)), /*#__PURE__*/React.createElement("div", {
    className: "blurBlock"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headerWrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "header cursorDefault"
  }, hint.title), /*#__PURE__*/React.createElement("button", {
    className: "headerBtn cursorDefault"
  }, /*#__PURE__*/React.createElement("img", {
    src: bluePlusImg,
    alt: "icon"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "blur-block__reminder"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    initiallyVisible: !showWithAnimation,
    animateIn: showWithAnimation ? 'animate__fadeInUp' : '',
    animateOnce: true,
    duration: 1.6
  }, /*#__PURE__*/React.createElement(Reminder, {
    lang: lang,
    event: hint,
    countryItems: countryItems,
    themeValues: reminderTheme,
    modeSlider: hitInSlider,
    eventsAnalytics: hitAnalytics,
    params: hitParams,
    isEventBlur: isEventBlur
  }))));
};
var CardStyledWrapper = /*#__PURE__*/styled("div")({
  name: "CardStyledWrapper",
  class: "cs4qdsz",
  vars: {
    "cs4qdsz-0": [function (props) {
      return props.cardType === EBlurCardImageTypes.deals ? '0 3px 6px 0 rgba(0,0,0,0.16)' : 'none';
    }],
    "cs4qdsz-1": [function (props) {
      return props.cardType === EBlurCardImageTypes.deals ? '5px' : '0';
    }]
  }
});
var ImageStyledWrapper = /*#__PURE__*/styled("div")({
  name: "ImageStyledWrapper",
  class: "i1514oa4",
  vars: {
    "i1514oa4-0": [function (props) {
      return props.isVerticalImage && props.cw ? '100%' : 'unset';
    }],
    "i1514oa4-1": [function (props) {
      return props.isVerticalImage && props.ch ? '100%' : 'unset';
    }],
    "i1514oa4-2": [function (props) {
      return props.isVerticalImage && props.cw ? "".concat(props.cw, "px") : 'unset';
    }],
    "i1514oa4-3": [function (props) {
      return props.isVerticalImage && props.ch ? "".concat(props.ch, "px") : 'unset';
    }],
    "i1514oa4-4": [function (props) {
      return "".concat(props.padding, "%");
    }],
    "i1514oa4-5": [function (props) {
      return props.cardType === EBlurCardImageTypes.deals ? "10px" : "0";
    }]
  }
});
var commonStyles = "cujt5fh";
export { BlurCard, isShowRuleIsHide, EBlurCardImageTypes };